import { render, staticRenderFns } from "./munuIndex.vue?vue&type=template&id=440bbcb7&scoped=true"
import script from "./munuIndex.vue?vue&type=script&lang=js"
export * from "./munuIndex.vue?vue&type=script&lang=js"
import style0 from "./munuIndex.vue?vue&type=style&index=0&id=440bbcb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440bbcb7",
  null
  
)

export default component.exports